import { render } from "./SendEmailCodeCard.vue?vue&type=template&id=40c093a7"
import script from "./SendEmailCodeCard.vue?vue&type=script&lang=js"
export * from "./SendEmailCodeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__